
// this keeps track of the event we are building through our decision tree, will be displayed on DOM
//to do: change structure of choice to be an array of objects with choice text and system feedback
const userDecisionData = (state = {"1": {question: '', choice: [] }, "2": {question: '', choice: [] }, "3": {question: '', choice: [] }, "4": {question: '', choice: [] }, "5": {question: '', choice: [] }, "6": {question: '', choice: [] }, "7": {question: '', choice: [] }, "8": {question: '', choice: [] }, "9": {question: '', choice: [] }}, action) => {
    if (action.type === 'ADD_DECISION_DATA')
    {
        let index = action.payload.index;
        let data = state;
        data[index].question = action.payload.question;
        data[index].choice.push({choice: action.payload.choice, feedback: action.payload.feedback});
        return data;
    } else if (action.type === 'RESET_USER_DECISION_DATA'){
        return action.payload;
    }
    else {
        return state; 
    }
}
export default userDecisionData;